// ABOUTME: Staff email one client member a new link to set their password.
// ABOUTME: The mutation toasts whether it was sent; the member list does not change.
import { useTranslation } from 'react-i18next';
import Button from '$components/Buttons/Button';
import { useResendCompanyMemberInviteMutation } from '$store/modules/companies';

type ResendInviteProps = {
  companyId: number;
  employerId: number;
};

const ResendInvite = ({ companyId, employerId }: ResendInviteProps) => {
  const [t, i18next] = useTranslation('global');
  const [resendInvite, { isLoading }] = useResendCompanyMemberInviteMutation();

  return (
    <Button
      text={t('CompaniesTable.ResendInvite')}
      showText
      disabled={isLoading}
      textStyles={{ color: '#079e88' }}
      onClick={() =>
        resendInvite({
          companyId,
          employerId,
          lang: i18next.language as 'en' | 'es',
        })
      }
    />
  );
};

export default ResendInvite;
